import styled from "@emotion/styled";
import { fontSizes } from "./typography";
import {
  breakpoints,
  fontWeight,
  zIndex,
  border as borderToken,
  text,
} from "@atlas-int/tokens";

export const SectionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column-reverse;
    position: relative;
    min-height: 100vh;
  }
`;

export const ScrollingContainer = styled.div`
  width: 50%;
  padding: 2rem;
  box-sizing: border-box;
  position: relative;
  z-index: ${zIndex.above};
  will-change: transform;

  @media (max-width: ${breakpoints.md}) {
    padding: 2rem 1rem;
    position: relative;
    z-index: ${zIndex.above};
    order: -1;
    margin: auto;
    will-change: transform;
  }

  @media (min-width: 600px) and (max-width: ${breakpoints.md}) {
    width: 70%;
  }

  @media (max-width: 600px) {
    width: 90%;
  }
`;

export const StepContainer = styled.div`
  width: 100%;
  display: flex;
  min-height: 20vh;

  @media (max-width: ${breakpoints.md}) {
    background: #fffffff2;
    border: solid 1px ${borderToken.subtle};
    margin: 90vh 0;
    min-height: auto;
    box-shadow:
      rgba(0, 0, 0, 0.15) 0px 10px 24px 0px,
      rgba(0, 0, 0, 0.05) 0px 2px 2px 0px,
      rgba(255, 255, 255, 0.04) 0px 0px 0px 1px inset;
  }
`;

export const StickyContainer = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  z-index: ${zIndex.base};

  /* Default scale factor for 50% width container */
  --container-scale: 1;

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
    position: sticky;
    top: 0;
    /* Scale factor doubles for full-width container */
    --container-scale: 2;
  }
`;

export const SectionHeader = styled.h2`
  font-size: ${fontSizes.sectionHeader};
  color: ${text.primary};
  font-weight: ${fontWeight.semibold};
`;

export const SectionSubheader = styled.h3`
  font-size: ${fontSizes.sectionSubheader};
  color: ${text.primary};
  margin: 0;
  font-weight: ${fontWeight.semibold};

  @media (max-width: ${breakpoints.md}) {
    margin-top: 1rem;
  }
`;
